import { render, staticRenderFns } from "./CatalogTags.vue?vue&type=template&id=e3a7b374&"
import script from "./CatalogTags.vue?vue&type=script&lang=js&"
export * from "./CatalogTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports